module.exports = __webpack_public_path__ + "img/home-icon.4d350409.svg";